import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import ChatBot from "../common_Components/ChatBot";
import WhatsAppButton from "../common_Components/WhatsAppButton";

const MainLayout = ({ children }) => {

  const getInitialLoginState = () => {
    if (typeof window === "undefined") return false;
    return Boolean(localStorage.getItem("token"));
  };
  const [isLoggedIn, setIsLoggedIn] = useState(getInitialLoginState);

  useEffect(() => {
    const handleAuthChange = () => {
      if (typeof window === "undefined") return;
      setIsLoggedIn(Boolean(localStorage.getItem("token")));
    };

    handleAuthChange();
    window.addEventListener("nutrajun-auth-change", handleAuthChange);
    return () => {
      window.removeEventListener("nutrajun-auth-change", handleAuthChange);
    };
  }, []);

  return (
        <>
          <Header />
          {children}
          <Footer /> 
          <ChatBot />
          {isLoggedIn && <WhatsAppButton />}
          {/* <WhatsAppButton /> */}
        </>
  );
};

export default MainLayout;
